var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3H14.4568C15.2439 3 15.9577 3.46157 16.2807 4.17927L17.6307 7.17927C17.6412 7.2027 17.6513 7.22628 17.6609 7.25H6.33911C6.3487 7.22628 6.35877 7.2027 6.36932 7.17927L7.71932 4.17927C8.04228 3.46157 8.75614 3 9.54316 3H11.25V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33911 8.75C6.3487 8.77372 6.35877 8.7973 6.36932 8.82073L7.71932 11.8207C8.04228 12.5384 8.75614 13 9.54316 13H11.25V15.325C9.53831 15.6725 8.24999 17.1858 8.24999 19C8.24999 21.0711 9.92892 22.75 12 22.75C14.0711 22.75 15.75 21.0711 15.75 19C15.75 18.5858 15.4142 18.25 15 18.25C14.5858 18.25 14.25 18.5858 14.25 19C14.25 20.2426 13.2426 21.25 12 21.25C10.7574 21.25 9.74999 20.2426 9.74999 19C9.74999 17.7574 10.7574 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16C12.75 15.9123 12.735 15.8282 12.7073 15.75C12.735 15.6718 12.75 15.5877 12.75 15.5V13H14.4568C15.2439 13 15.9577 12.5384 16.2807 11.8207L17.6307 8.82073C17.6412 8.7973 17.6513 8.77372 17.6609 8.75H6.33911Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/hook.b4f269284a9a0909644765b3474bc6b6.svg";
export { ForwardRef as ReactComponent };